import styled from 'styled-components';
import { Menu } from 'antd';

export const GhostMenu = styled(Menu)`
  background: transparent;
  color: white;
`;
